import { gql } from '@apollo/client';
import React from 'react';
import { Breakpoint } from '@moda/om';
import { SiteNavFragment } from '../../generated/types/SiteNavFragment';
import { DesktopSiteNav, DESKTOP_SITE_NAV_FRAGMENT } from './DesktopSiteNav';
import { MobileSiteNav } from './MobileSiteNav';

import './SiteNav.scss';

export const SITE_NAV_FRAGMENT = gql`
  fragment SiteNavFragment on DisplayPage {
    ...DesktopSiteNavFragment
  }
  ${DESKTOP_SITE_NAV_FRAGMENT}
`;

interface Props {
  displayPage?: SiteNavFragment | null;
}

export const SiteNav: React.FC<Props> = ({ displayPage }) => (
  <div className="SiteNav">
    <Breakpoint gt="md">
      <DesktopSiteNav displayPage={displayPage} />
    </Breakpoint>

    <Breakpoint lt="md">
      <MobileSiteNav />
    </Breakpoint>
  </div>
);
